const numberFormat = Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });

export const currencyFormat = number => {
    return numberFormat.format(number);
}
